import React from 'react'
import Chart from "./Chart"
import Markers from "./Markers"

import { useChartDimensions} from "./utils/chartHooks"

import "./Chart.css"

import * as d3 from 'd3'

import {map_color, map_marker, get_line_marker} from "./utils/shortcutMaps"
import Line from "./Line";

const BlindMap = ({ data, xAccessors, yAccessors, markers, colors, clickState, onClick, selectedPoint, mapType}) => {
    const [ref, dimensions] = useChartDimensions({})

    const xScale = d3.scaleLinear()
        .domain([
            d3.min(xAccessors.map((d) => (d3.min(data[0], d)))),
            d3.max(xAccessors.map((d) => (d3.max(data[0], d))))])
        .range([0, dimensions.boundedWidth])
        .nice();

    const yScale = d3.scaleLinear()
        .domain([
            d3.min(yAccessors.map((d) => (d3.min(data[0], d)))),
            d3.max(yAccessors.map((d) => (d3.max(data[0], d))))])
        .range([dimensions.boundedHeight, 0])
        .nice();

    const xAccessorsScaled = xAccessors.map((xAccessor) => (d => xScale(xAccessor(d))));
    const yAccessorsScaled = yAccessors.map((yAccessor) => (d => yScale(yAccessor(d))));

    const remapped_colors = colors.map((color) => (map_color(color)));
    const remapped_markers = markers.map((marker) => (map_marker(marker)));
    const line_styles = markers.map((marker) => (get_line_marker(marker)));

    const keyAccessor = (d, i) => i;
    return (
        <div className="ScatterPlot" ref={ref}>
            <Chart dimensions={dimensions}>
                {xAccessors.map((d, i) => {
                    if (remapped_markers[i] !== null) return (
                    <g className="DataPointsShown">
                        <Line
                            data={data[0]}
                            xAccessor={xAccessorsScaled[i]}
                            yAccessor={yAccessorsScaled[i]}
                            style={line_styles[i]}
                        />
                            <Markers
                            data={data[1]}
                            keyAccessor={keyAccessor}
                            xAccessor={xAccessorsScaled[i]}
                            yAccessor={yAccessorsScaled[i]}
                            type={remapped_markers[i]}
                            color={remapped_colors[i]}
                            selectedPoint={selectedPoint}
                            clickState={clickState}
                            onClick={onClick}
                            mapType={mapType}
                            />
                    </g>
                    )
                    else return (
                        <g className="DataPointsShown">
                            <Line
                                data={data[0]}
                                xAccessor={xAccessorsScaled[i]}
                                yAccessor={yAccessorsScaled[i]}
                                style={line_styles[i]}
                            />
                        </g>
                    )
                })}
            </Chart>
        </div>
    )
}

export default BlindMap